import React from 'react';
import { Colors, FontSize, LineHeight } from '@common/tokens';

export const DrawerTitle = ({ children }: { children: React.ReactNode }) => (
  <>
    <div className="drawer-title">{children}</div>
    <style jsx>
      {`
        .drawer-title {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          font-size: ${FontSize.md};
          line-height: ${LineHeight.md};
          padding: 16px 24px 16px 24px;
          border-bottom: solid 1px ${Colors.steelLighter};
        }
      `}
    </style>
  </>
);
